import { useEffect } from "react";
import { CanadaTopBar } from "../components/canada-tax/CanadaTopBar";
import { CanadaNavbar } from "../components/canada-tax/CanadaNavbar";
import { CanadaHeroSection } from "../components/canada-tax/CanadaHeroSection";
import { CanadaDeadlineStrip } from "../components/canada-tax/CanadaDeadlineStrip";
import { CanadaPainSection } from "../components/canada-tax/CanadaPainSection";
import { CanadaForSection } from "../components/canada-tax/CanadaForSection";
import { CanadaOfferSection } from "../components/canada-tax/CanadaOfferSection";
import { CanadaHowSection } from "../components/canada-tax/CanadaHowSection";
import { CanadaFAQSection } from "../components/canada-tax/CanadaFAQSection";
import { CanadaGuaranteeSection } from "../components/canada-tax/CanadaGuaranteeSection";
import { CanadaTestimonialsSection } from "../components/canada-tax/CanadaTestimonialsSection";
import { CanadaFinalCTASection } from "../components/canada-tax/CanadaFinalCTASection";
import { CanadaFooter } from "../components/canada-tax/CanadaFooter";

export default function CanadaTaxPage() {
  useEffect(() => {
    document.title = "Canada Tax Filing — $40 CAD | Done For You | CA Rahul Taneja";
  }, []);

  return (
    <div style={{ background: "#FFFFFF" }}>
      <CanadaTopBar />
      <CanadaNavbar />
      <CanadaHeroSection />
      <CanadaDeadlineStrip />
      <CanadaPainSection />
      <CanadaForSection />
      <CanadaOfferSection />
      <CanadaHowSection />
      <CanadaFAQSection />
      <CanadaGuaranteeSection />
      <CanadaTestimonialsSection />
      <CanadaFinalCTASection />
      <CanadaFooter />
    </div>
  );
}
